<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4">
        <v-col>
          <span
            class="text-h5 font-weight-bold"
            v-text="'Deleted Candidates'"
          ></span>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            @click="getData"
            title="Refresh"
          >
            <v-icon dark> mdi-refresh </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-text-field
                v-model="search"
                label="Search by name, email, reason or who ..."
                prepend-inner-icon="mdi-magnify"
                clearable
                dense
                outlined
              ></v-text-field>
            </v-card-text>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                    <th class="text-left">Rank</th>
                    <th class="text-left">Reason</th>
                    <th class="text-left" style="white-space: nowrap">
                      Deleted By
                    </th>
                    <th class="text-left" style="white-space: nowrap">
                      Deleted At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="filtered.length != 0">
                  <tr v-for="(row, i) in filtered" :key="`del${row.id}`">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.name || "" }}</td>
                    <td>{{ row.email || "" }}</td>
                    <td>{{ row.phone || "" }}</td>
                    <td>{{ row.rank || "" }}</td>
                    <td style="max-width: 240px; white-space: normal">
                      {{ row.deleted_reason || "" }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ row.deleted_by_name || "—" }}
                    </td>
                    <td style="white-space: nowrap">
                      {{ formatDate(row.deleted_at) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" class="text-center">
                      No deleted candidates found
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "DeletedCandidatesPage",
  data() {
    return {
      isLoading: false,
      rows: [],
      search: "",
    };
  },
  computed: {
    filtered() {
      if (!this.search) return this.rows;
      const q = this.search.toLowerCase();
      return this.rows.filter((r) => {
        return [
          r.name,
          r.email,
          r.phone,
          r.rank,
          r.deleted_reason,
          r.deleted_by_name,
          r.deleted_ip,
          r.deleted_device,
        ]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q));
      });
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "—";
      const m = moment(value);
      return m.isValid() ? m.format("DD MMM YYYY, hh:mm A") : value;
    },
    async getData() {
      this.isLoading = true;
      try {
        const response = await axios.get("users/deleted");
        this.rows = (response.data && response.data.data) || [];
      } catch (error) {
        console.error("Error fetching deleted candidates:", error);
        this.rows = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
